import React, { useContext } from 'react';

import CartEventsContext from '../../common/contexts/CartEventsContext';
import LocResourcesContext from '../../common/contexts/LocResourcesContext';
import {RewardShopArticle} from '../../common/utils/types';
import FiltersContext from '../contexts/FiltersContext';

import AddToCart from './AddToCart';

interface ArticlesTableProps {
    view: string;
}

const ArticlesTable: React.FC<ArticlesTableProps> = ({
   view
}) => {
  const GLOBAL_PREFIX = 'loy-bp-rws-overview';
  const ARTICLES_PRE_LOADED = 12;
  const { onFormatLocale } = useContext(LocResourcesContext);
  const { redeemableBalance, isLogged, isPromotionalArticle } = useContext(CartEventsContext);
  const { articlesFiltered } = useContext(FiltersContext);

  const promotionalPercentage = (article: RewardShopArticle) => {
    if (!article.originalPoints || !article.promotionalPrice) return 0;
    return Math.floor(
      ((article.originalPoints - article.promotionalPrice) * 100) / article.originalPoints,
    );
  };

  const renderInfoPoints = (article: RewardShopArticle) => {
    if (isPromotionalArticle?.(article)) {
      return (
        <div className={`${GLOBAL_PREFIX}_item--rebranding_info_points--promotion`}>
          <div
            className={`${GLOBAL_PREFIX}_item--rebranding_info_points 
                    ${GLOBAL_PREFIX}_item--rebranding_info_points--balance--promotion}`}>
            {article.currentPoints} {onFormatLocale?.('bp.points')}
          </div>
          <div
            className={`${GLOBAL_PREFIX}_item--rebranding_info_points ${GLOBAL_PREFIX}_item--rebranding_info_points--old-price`}>
            {article.originalPoints}
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={`${GLOBAL_PREFIX}_item--rebranding_info_points 
                ${GLOBAL_PREFIX}_item--rebranding_info_points--balance`}>
          {article.currentPoints} {onFormatLocale?.('bp.points')}
        </div>
      );
    }
  };

  return (
    <div className={`${GLOBAL_PREFIX}_items--rebranding`}>
      {articlesFiltered?.map((article, index) => {
        const hasBalance = redeemableBalance
          ? redeemableBalance >= (article.currentPoints ?? 0)
          : false;
        const prefix = isLogged ? '/account/bonus' : '/bonus';
        const path = `${article.productGroups[0].path.replace('/shop', prefix)}/${article.shopIdentifier}`;
        return (
          <div
            id={`general-${article.shopIdentifier}.0`}
            className={`${GLOBAL_PREFIX}_item--rebranding`}
            key={article.shopIdentifier}>
            <div className={`${GLOBAL_PREFIX}_item--rebranding_img`}>
              <a
                href={
                  article.articleType === 'Donation'
                    ? prefix + '/donations/' + article.shopIdentifier
                    : path
                }
                title={article.name}>
                <img
                  loading={index < ARTICLES_PRE_LOADED ? 'eager' : 'lazy'}
                  src={article.picture}
                  alt={article.name}
                  title={article.name}
                />
                {article.isNew === true ? (
                  <div className={`${GLOBAL_PREFIX}_item--rebranding__new_flag`}>
                    {onFormatLocale?.('product.article.badge.new')}
                  </div>
                ) : (
                  ''
                )}
                {isPromotionalArticle?.(article) ? (
                  <div className={`${GLOBAL_PREFIX}_item--rebranding__promotion`}>
                    - {promotionalPercentage(article)}%
                  </div>
                ) : (
                  ''
                )}
              </a>
            </div>
            <div className={`${GLOBAL_PREFIX}_item--rebranding_info`}>
              <div className={`${GLOBAL_PREFIX}_item--rebranding_info_link`}>
                <a
                  href={
                    article.articleType === 'Donation'
                      ? prefix + '/donations/' + article.shopIdentifier
                      : path
                  }
                  title={article.name}>
                  {article.name}
                </a>
              </div>
              {renderInfoPoints(article)}
              {!!redeemableBalance &&
                redeemableBalance !== -1 &&
                hasBalance &&
                article.currentPoints && (
                  <div className={`${GLOBAL_PREFIX}_item--rebranding_info_points`}>
                    <AddToCart
                      articleId={article.articleId}
                      articleShopId={article.shopIdentifier}
                      articleSelection={article.selection}
                      max={redeemableBalance / article.currentPoints}
                      quantityInCart={article.quantityInCart ?? 0}
                    />
                  </div>
                )}
              {view === 'private' && !hasBalance && (
                <div
                  className={`${GLOBAL_PREFIX}_item--rebranding_info_no_points`}>
                  {onFormatLocale?.('mzp.bonuspoints.savemore')}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ArticlesTable;
